export const GET_LEADSTAGEAGEINGS = "GET_LEADSTAGEAGEINGS";
export const ADD_LEADSTAGEAGEING = "ADD_LEADSTAGEAGEING";
export const EDIT_LEADSTAGEAGEING = "EDIT_LEADSTAGEAGEING";
export const GET_LEADSTAGEAGEING = "GET_LEADSTAGEAGEING";
export const RESET_LEADSTAGEAGEING = "RESET_LEADSTAGEAGEING";
export const ERROR_LEADSTAGEAGEING = "ERROR_LEADSTAGEAGEING";
export const GET_ALL_LEADSTAGEAGEINGS = "GET_ALL_LEADSTAGEAGEINGS";
